// extracted by mini-css-extract-plugin
module.exports = {"root":"root__1fA-N"};